import { render, staticRenderFns } from "./table.vue?vue&type=template&id=26cb6b8f&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb6b8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26cb6b8f')) {
      api.createRecord('26cb6b8f', component.options)
    } else {
      api.reload('26cb6b8f', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=26cb6b8f&scoped=true", function () {
      api.rerender('26cb6b8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign-template/table.vue"
export default component.exports